"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangeSelectorItems = exports.getDateSelectorItems = exports.getBooleanSelectorItems = exports.createTextSelector = exports.createSeparator = void 0;

var getDateSelectorItems = function getDateSelectorItems() {
  return [{
    id: 1,
    type: 'relative',
    name: 'Less than',
    value: 'lt',
    unit: 'hour'
  }, {
    id: 3,
    type: 'relative',
    name: 'More than',
    value: 'gt',
    unit: 'hour'
  }, {
    id: 4,
    type: 'absolute',
    name: 'Before',
    value: 'before'
  }, {
    id: 5,
    type: 'absolute',
    name: 'On',
    value: 'on'
  }, {
    id: 6,
    type: 'absolute',
    name: 'After',
    value: 'after'
  }, {
    id: 7,
    type: 'range',
    name: 'Custom date range',
    value: 'range'
  }];
};

exports.getDateSelectorItems = getDateSelectorItems;

var getRangeSelectorItems = function getRangeSelectorItems() {
  return [{
    id: 1,
    name: 'More than',
    value: 'gt'
  }, {
    id: 2,
    name: 'Equal to',
    value: 'eq'
  }, {
    id: 3,
    name: 'Less than',
    value: 'lt'
  }];
};

exports.getRangeSelectorItems = getRangeSelectorItems;

var getBooleanSelectorItems = function getBooleanSelectorItems() {
  return [{
    id: 1,
    name: 'Yes',
    value: true
  }, {
    id: 2,
    name: 'No',
    value: false
  }];
};

exports.getBooleanSelectorItems = getBooleanSelectorItems;

var createSeparator = function createSeparator() {
  return {
    type: 'separator'
  };
};

exports.createSeparator = createSeparator;

var createTextSelector = function createTextSelector(id, textNode) {
  return {
    id: "text-selector-".concat(id),
    name: textNode,
    type: 'text'
  };
};

exports.createTextSelector = createTextSelector;